<div class="batch-page">
  <div class="ss-page-header">
    <h1 class="ss-page-title">Batch List</h1>
  </div>

  <!-- Filter bar -->
  <div class="filter-bar">
    <input class="search-input" type="text" placeholder="Search by user…" [(ngModel)]="searchTerm" />

    <select class="status-select" [(ngModel)]="selectedStatus" (ngModelChange)="onStatusChange($event)">
      <option value="Open">Open (not finished)</option>
      <option value="">All</option>
      <option value="Pending">Pending</option>
      <option value="InProgress">In Progress</option>
      <option value="PartialComplete">Partial Complete</option>
      <option value="Picking">Picking</option>
      <option value="Picked">Picked</option>
      <option value="Verifying">Verifying</option>
      <option value="Completed">Completed</option>
      <option value="Incomplete">Incomplete</option>
      <option value="Cancelled">Cancelled</option>
      <option value="Refused">Refused</option>
    </select>

    <select class="status-select" *ngIf="!isStoreUser" [(ngModel)]="selectedStoreId" (ngModelChange)="onStoreChange($event)">
      <option [ngValue]="null">All Stores</option>
      <option *ngFor="let store of stores; trackBy: trackByStoreId" [ngValue]="store.storeId">{{ store.name }}</option>
    </select>
  </div>

  <!-- Loading -->
  <div class="ss-loading" *ngIf="loading">
    <div class="ss-spinner"></div> Loading…
  </div>

  <!-- Table -->
  <ng-container *ngIf="!loading">
    <div class="batch-table-wrap" *ngIf="filteredBatches.length > 0; else emptyState">
      <table class="ss-table">
        <thead>
          <tr>
            <th>User</th>
            <th>Status</th>
            <th>Created</th>
            <th>Rx</th>
            <th>Meds</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let batch of filteredBatches"
              [class.clickable]="isOpen(batch)"
              (click)="isOpen(batch) && openBatchDetailModal(batch)">
            <td>
              <ng-container *ngIf="getUserDisplay(batch.userName) as u">
                <div>
                  {{ u.name }}
                  <span *ngIf="isBatchPick(batch)"
                        class="badge bg-info text-dark ms-1">BATCH PICK</span>
                  <span *ngIf="batch.source === 'Mps'" data-test="mps-badge"
                        class="badge bg-warning text-dark ms-1">MPS</span>
                </div>
                <small *ngIf="batch.externalBatchId" style="color:var(--color-text-muted);display:block">
                  {{ batch.source === 'Mps' ? 'MPS ref' : 'Ref' }} {{ batch.externalBatchId }}</small>
                <small style="color:var(--color-text-muted)">{{ u.email }}</small>
              </ng-container>
            </td>
            <td>
              <span class="ss-status" [ngClass]="getStatusClass(batch.status)">{{ batch.status }}</span>
              <small *ngIf="batch.status === 'Pending'" style="color:var(--color-text-muted);display:block;font-size:11px">{{ calculatePendingTime(batch.createdAt) }}</small>
            </td>
            <td style="color:var(--color-text-muted);font-size:12px">{{ batch.createdAt | date: 'dd MMM yy, HH:mm' }}</td>
            <td>{{ batch.prescriptions.length }}</td>
            <td>{{ getMedicationCount(batch) }}</td>
            <td>
              <div class="row-actions" (click)="$event.stopPropagation()">
                <button class="ss-btn ss-btn-success ss-btn-sm"
                  *ngIf="(batch.status === 'Pending' || batch.status === 'InProgress' || batch.status === 'PartialComplete') && isStoreUser"
                  (click)="printPickList(batch.batchId)">Pick List</button>
                <button class="ss-btn ss-btn-primary ss-btn-sm"
                  *ngIf="(batch.status === 'Pending' || batch.status === 'InProgress' || batch.status === 'PartialComplete' || batch.status === 'Picking' || batch.status === 'Picked' || batch.status === 'Verifying') && isStoreUser"
                  (click)="scanBatch(batch.batchId, batch)">Start Scan</button>
                <button class="ss-btn ss-btn-secondary ss-btn-sm" data-test="bag-labels" *ngIf="canReprintBags(batch)"
                  (click)="openBagLabels(batch)">Bag labels</button>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <ng-template #emptyState>
      <div class="ss-empty">No batches found.</div>
    </ng-template>

    <div class="pagination-bar" *ngIf="currentPage > 1 || hasNextPage">
      <button class="ss-btn ss-btn-secondary ss-btn-sm" (click)="getAllBatch(currentPage - 1)" [disabled]="currentPage === 1">Previous</button>
      <span class="pagination-page">Page {{ currentPage }}</span>
      <button class="ss-btn ss-btn-secondary ss-btn-sm" (click)="getAllBatch(currentPage + 1)" [disabled]="!hasNextPage">Next</button>
    </div>
  </ng-container>
</div>

<!-- Print section (hidden) -->
<!-- Batch Detail Modal -->
<div class="modal fade" id="batchDetailModal" tabindex="-1" aria-hidden="true" data-bs-backdrop="static" data-bs-keyboard="false">
  <div class="modal-dialog modal-lg modal-dialog-scrollable">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title">Batch: {{ selectedBatch?.batchId }}</h5>
        <button type="button" class="btn-close" data-bs-dismiss="modal"></button>
      </div>
      <div class="modal-body">
        <div *ngIf="selectedBatch">
          <div class="summary-container">
            <div class="summary-box">
              <div>
                <div class="summary-label">Prescriptions</div>
                <div class="summary-value">{{ selectedBatch.prescriptions.length }}</div>
              </div>
            </div>
            <div class="summary-box">
              <div>
                <div class="summary-label">Medications</div>
                <div class="summary-value">{{ getMedicationCount(selectedBatch) }}</div>
              </div>
            </div>
          </div>

          <div class="button-container" *ngIf="isStoreUser">
            <button class="ss-btn ss-btn-success" (click)="printPickList(selectedBatch.batchId)">Print Pick List</button>
            <button class="ss-btn ss-btn-primary" *ngIf="isOpen(selectedBatch)" (click)="scanBatch(selectedBatch.batchId)">Start Scan</button>
          </div>

          <div class="patient-list" style="margin-top:14px">
            <div class="patient-item" *ngFor="let patient of summary.patientSummaries">
              <div class="patient-header" (click)="togglePatient(patient)">
                <strong>{{ patient.patientName }}</strong>
                <span class="click-toggle">{{ patient.expanded ? 'Hide' : 'Show' }}</span>
              </div>
              <div *ngIf="patient.expanded" class="medicine-collapse">
                <div *ngFor="let med of patient.medications" class="medicine-row">
                  <span>{{ med.medicationName }} {{ med.dosage }}</span>
                  <span [ngClass]="med.isAvailable ? 'status-scanned' : 'status-pending'">
                    {{ med.isAvailable ? 'SCANNED' : 'PENDING' }}
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
